import React from 'react'
import { makeStyles } from "@material-ui/core";
import { Link } from "react-router-dom";
import "../../../_assets/sass/footer.scss";
import * as helpers from "../../../../app/util/helpers";

const useStyles = makeStyles((theme) => ({
  footer: {
    padding: "0 25px",
    flexGrow: 1
  },
  footerMobile: {
    padding: '0 25px',
    flexGrow: 1,
    flexDirection: 'column-reverse !important'
  }
}));

export function Footer() {
  const today = new Date().getFullYear();
  const classes = useStyles();

  const wrapClass = `d-flex flex-column flex-md-row align-items-center justify-content-between ${classes.footer}`

  return (
    <div className={`footer py-4 d-flex flex-lg-column`} id="kt_footer">
      <div className={wrapClass}>
        <div className={"text-dark order-2 order-md-1"} id='footer-reserve-text'>
          <div>
            <span className="footer-innitial text-muted font-weight-bold mr-2">
              &copy; {today.toString()}
            </span>{" "}
            <span className="footer-title" style={{textWrap: 'nowrap'}}>
              Super Receptionist. Powered by Knowlarity.
            </span>
          </div>
          <div>
            <span className="text-muted">All Rights Reserved</span>
          </div>
        </div>
        <div className="nav nav-dark order-1 order-md-2">
          <a
            href="https://www.knowlarity.com/aboutus"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link pr-3 pl-0 footer-link"
          >
            About Us
          </a>
          <Link to="/docs" className="nav-link px-3 footer-link">
            {" "}
            Docs
          </Link>
          {/* </a> */}
          {/* <a
            href="https://srbetadoc.knowlarity.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link px-3 footer-link"
          > */}

          {/* </a> */}
          <a
            href="https://www.knowlarity.com/contact-us"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link pl-3 pr-0 footer-link"
          >
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
}
